module.exports = __webpack_public_path__ + "static/media/app-9@2x.6a9d9269.png";